import React, { useState } from 'react'

import { cx } from '@linaria/core'

import { Heading } from '../data-display/Heading'
import { Container } from './Container'

function useScrollDirection(props: {
  upThreshold: number
  downThreshold: number
}) {
  const [scrollDirection, setScrollDirection] = React.useState<
    'up' | 'down' | null
  >(null)
  const [scrollY, setScrollY] = useState(0)

  React.useEffect(() => {
    let lastScrollY = window.pageYOffset

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset
      const direction = scrollY > lastScrollY ? 'down' : 'up'
      setScrollY(scrollY)
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > props.downThreshold ||
          scrollY - lastScrollY < -props.upThreshold)
      ) {
        setScrollDirection(direction)
      }
      lastScrollY = scrollY > 0 ? scrollY : 0
    }

    window.addEventListener('scroll', updateScrollDirection) // add event listener
    return () => {
      window.removeEventListener('scroll', updateScrollDirection) // clean up
    }
  }, [scrollDirection, props.downThreshold, props.upThreshold])

  return { scrollDirection, scrollY }
}

// tailwind JIT の関係上 className へはハードコードするが、外の要素からやむをえずヘッダーサイズを知りたい場合に利用する
export const headerHeight = '50px'

export const Header: React.FC<{
  children: React.ReactNode
  withoutSpacing?: boolean
  withoutFixed?: boolean
}> = (props) => {
  const { scrollDirection, scrollY } = useScrollDirection({
    upThreshold: 5,
    downThreshold: 5,
  })

  return (
    <>
      <div
        className={cx(
          'top-0 w-full z-10 transition-all duration-300 h-[50px]',
          !props.withoutFixed && 'fixed',
          scrollY > 124 && scrollDirection === 'down' ? '-top-[50px]' : 'top-0'
        )}
      >
        <Heading variant="h1" component="h1">
          <Container>
            <div className="flex items-center justify-between w-full">
              {props.children}
            </div>
          </Container>
        </Heading>
      </div>
      {!props.withoutSpacing && <div className="h-[50px]" />}
    </>
  )
}
